'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _MultiFormContainer = require('../../common/MultiFormContainer');

var _MultiFormContainer2 = _interopRequireDefault(_MultiFormContainer);

var _GetQuoteContainer = require('../GetQuoteContainer');

var _GetQuoteContainer2 = _interopRequireDefault(_GetQuoteContainer);

var _CompleteApplicationContainer = require('../CompleteApplicationContainer');

var _CompleteApplicationContainer2 = _interopRequireDefault(_CompleteApplicationContainer);

var _ConfirmationContainer = require('../../common/ConfirmationContainer');

var _ConfirmationContainer2 = _interopRequireDefault(_ConfirmationContainer);

var _ActionCreators = require('../../../actions/ActionCreators');

var _translate = require('../../../language/translate');

var _commonFunctions = require('../../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkelIsComponent = function (_React$Component) {
  _inherits(MarkelIsComponent, _React$Component);

  function MarkelIsComponent(props) {
    _classCallCheck(this, MarkelIsComponent);

    var _this = _possibleConstructorReturn(this, (MarkelIsComponent.__proto__ || Object.getPrototypeOf(MarkelIsComponent)).call(this, props));

    _this.fetchedDataPopulated = [false, false];

    _this.source = 'studentaccidentplan';
    return _this;
  }

  _createClass(MarkelIsComponent, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _commonFunctions.mountForm)(this);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'toggleFetcheDataPopulated',
    value: function toggleFetcheDataPopulated(step) {
      return !this.fetchedDataPopulated[step] && (this.fetchedDataPopulated[step] = true);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.formConfig.loaded && (0, _commonFunctions.loadForm)(this) && _react2.default.createElement(
        _MultiFormContainer2.default,
        (0, _commonFunctions.getContainerProps)(this),
        _react2.default.createElement(_GetQuoteContainer2.default, {
          toggleFetcheDataPopulated: this.toggleFetcheDataPopulated.bind(this),
          quoteEnabled: true,
          params: this.props.params,
          onSubmit: this.props.forward,
          trackingCode: this.props.location.query.tracking_code,
          formName: this.source,
          eachApplicantHasSchool: true
        }),
        _react2.default.createElement(_CompleteApplicationContainer2.default, {
          toggleFetcheDataPopulated: this.toggleFetcheDataPopulated.bind(this),
          params: this.props.params,
          forward: this.props.forward,
          back: this.props.back,
          formName: this.source,
          eachApplicantHasSchool: true,
          hasBeneficiary: true,
          beneficiaryAddress: true,
          hasGuardian: true,
          addressCountry: 'CA',
          studentEmailTitle: true
        }),
        _react2.default.createElement(_ConfirmationContainer2.default, {
          params: this.props.params
        })
      );
    }
  }]);

  return MarkelIsComponent;
}(_react2.default.Component);

MarkelIsComponent.propTypes = {
  params: _react2.default.PropTypes.object,
  getAuth: _react2.default.PropTypes.func.isRequired,
  getFormConfig: _react2.default.PropTypes.func.isRequired,
  getSavedQuote: _react2.default.PropTypes.func.isRequired,
  savedQuoteLoaded: _react2.default.PropTypes.bool.isRequired,
  forward: _react2.default.PropTypes.func.isRequired,
  back: _react2.default.PropTypes.func.isRequired,
  formConfig: _react2.default.PropTypes.object.isRequired,
  location: _react2.default.PropTypes.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    formConfig: state.formConfig,
    savedQuoteLoaded: state.savedQuote.loaded
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAuth: function getAuth() {
      return dispatch(_ActionCreators.getAuthorization.apply(undefined, arguments));
    },
    getFormConfig: function getFormConfig() {
      return dispatch(_ActionCreators.getFormConfiguration.apply(undefined, arguments));
    },
    getSavedQuote: function getSavedQuote() {
      return dispatch(_ActionCreators.getSavedQuote.apply(undefined, arguments));
    },
    getRenewal: function getRenewal() {
      return dispatch(_ActionCreators.getRenewal.apply(undefined, arguments));
    },
    forward: function forward() {
      return dispatch((0, _ActionCreators.forwardPage)());
    },
    back: function back() {
      return dispatch((0, _ActionCreators.backPage)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MarkelIsComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/student_accident/lloyds/StudentAccidentContainer.jsx
// module id = 1716
// module chunks = 0